import React from 'react';
import styles from '../../css/Part6.module.css';

function MerchantSection() {
    return (
        <section className={styles.section}>
            <header className={styles.header}>
                More Merchants Awaits You
            </header>
            <div className={styles.content}>
                <div className={styles.contentWrapper}>

                    {/* Bill Payments */}
                    <div className={styles.categoryRow}>
                        <div className={styles.categoryItem}>Bill Payments</div>
                        <div className={styles.merchantImages}>
                            <img src="images/brand/Mobile Sources/logo merchant brand-01.png" alt="Merchant 1" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-02.png" alt="Merchant 2" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-03.png" alt="Merchant 3" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-04.png" alt="Merchant 4" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-05.png" alt="Merchant 5" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-06.png" alt="Merchant 6" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-07.png" alt="Merchant 7" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-08.png" alt="Merchant 8" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-09.png" alt="Merchant 9" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-10.png" alt="Merchant 10" />
                        </div>
                    </div>

                    {/* Transport */}
                    <div className={styles.categoryRow}>
                        <div className={styles.categoryItem}>Transport</div>
                        <div className={styles.merchantImages}>
                            <img src="images/brand/Mobile Sources/logo merchant brand-11.png" alt="Transport1" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-12.png" alt="Transport2" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-13.png" alt="Transport3" />
                        </div>
                    </div>

                    {/* Online Shop */}
                    <div className={styles.categoryRow}>
                        <div className={styles.categoryItem}>Online Shop</div>
                        <div className={styles.merchantImages}>
                            <img src="images/brand/Mobile Sources/logo merchant brand-14.png" alt="Shop 1" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-16.png" alt="Shop 2" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-17.png" alt="Shop 3" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-18.png" alt="Shop 4" />
                        </div>
                    </div>

                    {/* Food & Beverage */}
                    <div className={styles.categoryRow}>
                        <div className={styles.categoryItem}>Food & Beverage</div>
                        <div className={styles.merchantImages}>
                            <img src="images/brand/Mobile Sources/logo merchant brand-19.png" alt="Food 1" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-20.png" alt="Food 2" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-21.png" alt="Food 3" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-22.png" alt="Food 4" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-23.png" alt="Food 5" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-24.png" alt="Food 6" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-25.png" alt="Food 7" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-26.png" alt="Food 8" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-27.png" alt="Food 9" />
                            <img src="images/brand/Mobile Sources/logo merchant brand-28.png" alt="Food 10" />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default MerchantSection;
